<div class="google-searcher {{styleClass}}"
     [class.disabled]="disabled"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted || validationExternalErrorText)">
  <ng-container *ngIf="!hideLabel">
    <si-label [text]="text"
              [tooltipText]="tooltipText"
              [tooltipPosition]="tooltipPosition"
              [tooltipIcon]="tooltipIcon"
              [tooltipStyleClass]="tooltipStyleClass"
              [tooltipEscape]="tooltipEscape"
              forId="google-searcher-{{id}}"
    ></si-label>
  </ng-container>
  <div class="google-searcher_input" siProvideParentForm>
    <input #formModel="ngModel"
           #placesRef="ngx-places"
           ngx-google-places-autocomplete
           id="google-searcher-{{id}}"
           name="{{name}}"
           placeholder="{{placeholder | translate}}"
           [disabled]="disabled"
           [siAutoFocus]="autoFocus"
           [options]="ngxPlacesInputOptions"
           [ngModel]="model?.formatted_address"
           [ngModelOptions]="{updateOn: updateNgModelOnBlur ? 'blur' : 'change'}"
           (ngModelChange)="onChangeModel($event)"
           siValidation="{{rule}}"
           [siValidationElement]="validationElement"
           [siValidationExternalErrorText]="validationExternalErrorText"
           (onAddressChange)="handleAddressChange($event)">
    <si-validation-element #validationElement
                           [formModel]="formModel"
                           [showErrorText]="!showRuleErrorOutsideIcon"
                           (errorTextChange)="validationErrorText = $event"
                           class="google-searcher_input_validation"
    ></si-validation-element>
    <i class="icosun-search google-searcher_input_icon"></i>
  </div>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
